import { useParams } from "react-router-dom"
import { useMatchIdMapping } from "../../../../hooks/useMatchIdMapping.js"
import { useNavigateTo } from "../../../../hooks/useNavigateTo.js"
import { useOrderedStructure } from "../../../../hooks/useOrderedStructure.js"
import { FormControl, InputLabel, Select } from "@mui/material"
import useStyles from '../../../../../styles/global-mui.js';
import React, { useEffect } from "react"
import { formatRoundLabel } from "../../../../../components/Live/utils/helpers.js"

// TODO handle error: 
// useLiveResolver.js:29 Warning: Select elements must be either controlled or uncontrolled 
// (specify either the value prop, or the defaultValue prop, but not both). 
// Decide between using a controlled or uncontrolled select element and remove one of these

export const MatchsDisplay = ({live}) => {

    const { idMatch } = useParams();

    const navigateTo = useNavigateTo()
        const [matchIdMapping] = useMatchIdMapping(live)
    
        const [orderedStructure, competitionMap] = useOrderedStructure(live)
    
        const navigateToMatch = (matchId) => {
            navigateTo(matchId); // Ajouter l'ID du match à l'URL
        }

        useEffect(() => {

            if (orderedStructure) {
                // Trouver le premier match de la structure
                for (const [discipline, competitions] of Object.entries(orderedStructure)) {
                    if (discipline) {
                        for (const [competitionId, days] of Object.entries(competitions)) {
                            if (days) {
                                for (const [day, dates] of Object.entries(days)) {
                                    if (dates) {
                                        for (const [date, matchs] of Object.entries(dates)) {
                                            if (matchs && matchs.length > 0) {
                                                // Prendre le premier match
                                                const firstMatch = matchs[0];

                                                if(!idMatch)
                                                    navigateToMatch(firstMatch.idMatch);
                                                return; // Stopper la recherche après avoir trouvé le premier match
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }, [orderedStructure]);
    
        
        const classes = useStyles();
        

        return (
            <>
            <FormControl className={classes.customInput}>
            <InputLabel htmlFor="grouped-match-select" id="match-select-label">
                Matchs
            </InputLabel>
            <Select
                native
                defaultValue=""
                id="grouped-match-select"
                labelId="match-select-label"
                onChange={(e) => navigateToMatch(e.target.value)}
                value={idMatch}
            >
                {orderedStructure &&
                Object.entries(orderedStructure).map(([discipline, competitions]) => (
                    discipline &&
                    Object.entries(competitions).map(([competitionId, days]) => (
                    days &&
                    Object.entries(days).map(([day, dates]) => (
                        <React.Fragment key={day}>
                        <optgroup
                            label={
                            competitionMap.get(competitionId).name +
                            " " +
                            competitionMap.get(competitionId).season +
                            " : " +
                            formatRoundLabel(day)
                            }
                            style={{ textTransform: "uppercase" }}
                        />
                        {dates &&
                            Object.entries(dates)
                            .sort(([dateA, matchsA], [dateB, matchsB]) => {
                                const dateAValue = new Date(matchsA[0].dateTime);
                                const dateBValue = new Date(matchsB[0].dateTime);
                                return dateAValue - dateBValue;
                            })
                            .map(([date, matchs]) =>
                                matchs &&
                                matchs
                                .sort(
                                    (a, b) =>
                                    new Date(a.dateTime) - new Date(b.dateTime)
                                )
                                .map((match) => (
                                    <option
                                    key={match.idMatch}
                                    value={match.idMatch}
                                    style={{ textTransform: "uppercase" }}
                                    >
                                    {"J" +
                                        match.day +
                                        ": " +
                                        match.homeTeam.name +
                                        "-" +
                                        match.awayTeam.name}
                                    </option>
                                ))
                            )}
                        </React.Fragment>
                    ))
                    ))
                ))}
            </Select>
            </FormControl>
        </>
        )
}